// Shared ISOTYPE pin builder, brand-aligned (per phoniq_brand.pdf): a flat
// pictogram inside a circular token — the same round language as the cluster
// bubbles and farm dots, not a generic teardrop. Used by the Landanlegg
// (onshore.ts) and Servicehavner (serviceports.ts) layers; each passes its own
// fill / ring / glyph so authoritative (solid mint) and inferred (Deep token,
// mint ring) read as one family distinguished by glyph, not by clashing colour.

import maplibregl from "maplibre-gl";

const SIZE = 44;
const R = 18;
const C = SIZE / 2;

/** A circular token. `glyph` is markup centred on the origin (the builder
 *  translates it to the centre). */
export function pinSVG(fill: string, stroke: string, glyph: string): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}">` +
    `<circle cx="${C}" cy="${C}" r="${R}" fill="${fill}" stroke="${stroke}" stroke-width="2.5"/>` +
    `<g transform="translate(${C},${C})">${glyph}</g>` +
    `</svg>`
  );
}

/** Rasterise an SVG pin and register it as a map image (idempotent). */
export async function addPin(map: maplibregl.Map, id: string, svg: string): Promise<void> {
  if (map.hasImage(id)) return;
  const ratio = 2;
  const img = new Image(SIZE, SIZE);
  await new Promise<void>((resolve) => {
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  });
  const canvas = document.createElement("canvas");
  canvas.width = SIZE * ratio;
  canvas.height = SIZE * ratio;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.drawImage(img, 0, 0, SIZE * ratio, SIZE * ratio);
  if (!map.hasImage(id)) {
    map.addImage(id, ctx.getImageData(0, 0, SIZE * ratio, SIZE * ratio), { pixelRatio: ratio });
  }
}
